export default "__VITE_ASSET__Ct3w8oX6__"